import React, { FC } from 'react';

import { scale as initialScale } from '@components/frame';
import Svg from '@styles/icons/svg';
import type { ScaleFunction } from '@components/operatorPanel/interfaces';

export interface AddImageIconProps {
  color: string;
  scale?: ScaleFunction;
}

export const AddImageIcon: FC<AddImageIconProps> = ({ color, scale = initialScale }) => (
  <Svg icon="addPicture" color={color} width={scale(38)} height={scale(28)} key={scale(21)} />
);
